var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("找不到页面")]),_c('span',[_vm._v(_vm._s(_vm.path))])])}
var staticRenderFns = []

export { render, staticRenderFns }